import type { TaskCardRowPadding } from "src/components/Tasks/TaskCard";

export const DASHBOARD_ITEM_PADDING_CLASS_NAME = "px-3 py-2";

export const DASHBOARD_ITEM_PADDING_SX: TaskCardRowPadding = {
  paddingTop: "8px",
  paddingRight: "8px",
  paddingBottom: "8px",
  paddingLeft: "8px",
};
